/**
 * The reader's-language label of a stored `items.contract_type` value (`shared/contractTypes.ts`),
 * for the document-type chips (MAR-979). The chips used to print the raw value, so a Spanish session
 * read "rental" or "other".
 *
 * A value with no label — a class a classifier started writing before the locales caught up — is
 * shown as stored rather than as a raw key path. Pass `useI18n()`'s `t` and `te`.
 */
export function contractTypeLabel(
  value: string | null | undefined,
  i18n: { t: (key: string) => string; te: (key: string) => boolean },
): string {
  if (!value) return ''
  const key = `documents.contractTypes.${value}`
  return i18n.te(key) ? i18n.t(key) : value
}
